import { Box, CircularProgress, Typography } from "@mui/material";
import { MillLocalserverLiveStatusContext } from "contexts/MillLocalserverLiveStatusContext/MillLocalserverLiveStatusContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

export const StatusLight = () => {
    const { t } = useTranslation();
    const { isDisconnected, loading } = useContext(MillLocalserverLiveStatusContext);

    if (loading) {
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress color="info" size={20} />
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
                sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: isDisconnected ? "#F9C13D" : "#3CB371",
                    boxShadow: isDisconnected ? "0 0 5px 2px #F9C13D" : "0 0 5px 2px #3CB371",
                    transition: "all 0.3s ease",
                }}
            />
            <Typography variant="body2">
                {isDisconnected
                    ? t("locations.mill_network_details.disconnected")
                    : t("locations.mill_network_details.connected")}
            </Typography>
        </Box>
    );
};
